import { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import 'swiper/components/pagination/pagination.less'
import { IconFont } from '@/components'
import { Typography, Tooltip } from 'antd'
import { safeJSONParse } from '@/utils'
import { t } from '@/i18n'
SwiperCore.use([Autoplay, Navigation, Pagination])
const DetailLog = props => {
  const { index, data, dataList } = props
  const [isRaw, setIsRaw] = useState(false)
  const [num, setNum] = useState(undefined)

  useEffect(() => {
    setNum(index)
  }, [index])

  const interceptStatusMap = {
    ResourceDeviceStatusInterceptSuccess: t('拦截成功'),
    ResourceDeviceStatusProtectionInvalid: t('防护失效'),
    ResourceDeviceStatusDetectSuccess: t('检测成功'),
    ResourceDeviceStatusNotInvolved: t('不涉及'),
  }

  const devices = useMemo(
    () =>
      data?.device_log?.map(item => ({
        origin_device_ip: item.origin_device_ip,
        origin_device_type: item.origin_device_type,
        origin_device_brand: item.origin_device_brand,
      })) || [],
    [data],
  )

  const parseContent = useMemo(
    () => data?.device_log?.map(item => item.parse_content) || [],
    [data],
  )

  const content = useMemo(() => data?.device_log?.map(item => item.content) || [], [data])

  const filtration = [
    { id: 'datasource_name', name: t('日志源'), disabled: false },
    { id: 'device_ip', name: t('设备IP'), disabled: false },
    { id: 'commander', name: t('负责人'), disabled: false },
    { id: 'cve_id', name: 'CVE_ID', disabled: false },
    { id: 'cnvd_id', name: 'CNVD_ID', disabled: false },
    { id: 'sip', name: t('源IP'), disabled: false },
    { id: 'sport', name: t('源端口'), disabled: false },
    { id: 'dip', name: t('目的IP'), disabled: false },
    { id: 'dport', name: t('目的端口'), disabled: false },
    { id: 'alert_name', name: t('告警名称'), disabled: false },
    { id: 'protocol', name: t('协议'), disabled: false },
    { id: 'x_forward_for', name: 'X_forward_for', disabled: false },
    { id: 'url', name: 'Url', disabled: false },
    { id: 'host', name: 'Host', disabled: false },
    { id: 'asbas_id', name: 'Asbas-Id', disabled: false },
    { id: 'method', name: t('请求方法'), disabled: false },
    { id: 'device_rule_name', name: t('关联安全设备规则名称'), disabled: false },
    { id: 'device_rule_id', name: t('关联安全设备规则ID'), disabled: false },
    { id: 'alert_time', name: t('原始告警日志时间'), disabled: false },
    { id: 'alert_level', name: t('告警等级'), disabled: false },
    { id: 'handle_action', name: t('处置动作'), disabled: false },
    { id: 'event_type', name: t('告警类型'), disabled: false },
    { id: 'agent_ip', name: t('客户端IP'), disabled: false },
    { id: 'service', name: t('服务名称'), disabled: false },
    { id: 'uname', name: t('爆破账号'), disabled: false },
    { id: 'pname', name: t('提权进程'), disabled: false },
    { id: 'sha_256', name: 'sha_256', disabled: false },
    { id: 'filepath', name: t('文件路径'), disabled: false },
  ]

  return (
    <>
      {num !== undefined && (
        <LogItem>
          <div className="line">
            <div style={{ marginRight: 6, display: 'flex', marginTop: 6 }}>
              <span style={{ marginRight: 6, width: '45px' }}>
                {data?.device_log?.length > 0 ? (
                  <TagAlarm color={'#F44F4F'}>{t('有告警')}</TagAlarm>
                ) : (
                  <TagAlarm color={'#3586FF'}>{t('无告警')}</TagAlarm>
                )}
              </span>
              {data?.device_status === 'ResourceDeviceStatusInterceptSuccess' && (
                <span className="intercept">{t('拦截成功')}</span>
              )}
              {data?.device_status === 'ResourceDeviceStatusDetectSuccess' && (
                <span className="intercept-err" style={{ color: '#72b851', background: '#e9f5e3' }}>
                  {t('检测成功')}
                </span>
              )}
              {data?.device_status === 'ResourceDeviceStatusProtectionInvalid' && (
                <span className="intercept-err">{t('防护失效')}</span>
              )}
            </div>
            <div style={{ marginRight: 6 }}>
              {data?.device_type === 'SOC' ? <TagAlarm color={'#FF7787'}>SOC</TagAlarm> : null}
            </div>
            <div className="company">
              <div className="title" style={{ marginRight: '0', width: '70px' }}>
                {t('设备厂商：')}
              </div>
              <Typography.Text
                ellipsis={{ tooltip: { getTooltipContainer: () => document.body } }}
                className="text"
              >
                {data?.device_brand}
              </Typography.Text>
            </div>
            <div className="company">
              <div
                className="title"
                style={{ marginRight: '0', width: '70px', marginLeft: '10px' }}
              >
                {t('设备类型：')}
              </div>
              <Typography.Text ellipsis={{ tooltip: { getTooltipContainer: () => document.body } }}>
                {data?.device_type}
              </Typography.Text>
            </div>
          </div>
          <div className="line">
            <div className="title" style={{ marginRight: '0', width: '70px' }}>
              {t('设备名称：')}
            </div>
            <div className="page">
              <>
                <Typography.Text
                  ellipsis={{
                    tooltip: { title: data?.device_name, getPopupContainer: () => document.body },
                  }}
                >
                  <span style={{ color: '#666' }}>
                    {`${data?.device_name}(${data?.device_ip})`}
                  </span>
                </Typography.Text>
              </>
              {data?.device_log?.length > 0 && (
                <Tabs style={{ marginRight: '10px' }}>
                  <div
                    className={isRaw ? 'tab' : 'active tab'}
                    onClick={() => {
                      setIsRaw(false)
                    }}
                  >
                    {t('解析日志')}
                  </div>
                  <div
                    className={isRaw ? 'active tab' : 'tab'}
                    onClick={() => {
                      setIsRaw(true)
                    }}
                  >
                    {t('原始日志')}
                  </div>
                </Tabs>
              )}
            </div>
          </div>
          {data?.device_log?.length > 0 && !isRaw ? (
            <>
              <div className="line">
                <div className="title" style={{ marginRight: '0', width: '70px' }}>
                  {t('日志数量：')}
                </div>
                <div className="page">
                  <div className={`pag pag${num}`} />
                  <div style={{ display: data?.device_log?.length === 1 ? 'none' : 'block' }}>
                    <div className={`prev less-prev${num}`}>
                      <IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />
                    </div>
                    <div className={`prev next less-next${num}`} style={{ marginRight: '10px' }}>
                      <IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="content1">
                <Swiper
                  spaceBetween={20}
                  navigation={{
                    prevEl: `.less-prev${num}`,
                    nextEl: `.less-next${num}`,
                    hideOnClick: true,
                  }}
                  pagination={{
                    type: 'fraction',
                    el: `.pag${num}`,
                  }}
                  loop
                >
                  {parseContent?.map((item, i) => {
                    console.log('item', typeof item)
                    const JsonParseContent = safeJSONParse(item)
                    let matchText = ''
                    let matchTip = ''
                    if (String(JsonParseContent?.match_mode) === '1') {
                      matchText = t('攻击标识')
                      matchTip = `根据日志URL中的X- BAS-ATTACK- ID进行匹配，当前用例ID 值为${JsonParseContent?.x_bas_attack_id}`
                    } else if (String(JsonParseContent?.match_mode) === '2') {
                      matchText = t('四元组')
                      matchTip = `根据日志中源IP、目标IP、源端口、目标端口进行匹配，当前用例源目地址为${JsonParseContent?.sip}:${JsonParseContent?.sport}、${JsonParseContent?.dip}:${JsonParseContent?.dport}`
                    } else if (String(JsonParseContent?.match_mode) === '3') {
                      matchText = 'Payload'
                      matchTip = t(
                        '根据日志中攻击用例的Payload正文进行匹配，详情见日志原文Payload内容',
                      )
                    }
                    return (
                      <SwiperSlide key={i}>
                        <>
                          {['1', '2', '3'].includes(String(JsonParseContent?.match_mode)) && (
                            <div className="log-match">
                              {t('日志匹配模式：')}
                              <span style={{ marginRight: 5, color: '#999' }}>{matchText}</span>
                              <Tooltip
                                title={matchTip}
                                placement="top"
                                getPopupContainer={() => document.body}
                              >
                                <IconFont
                                  type="icon-tishi"
                                  style={{ marginRight: '6px', color: '#999' }}
                                />
                              </Tooltip>
                            </div>
                          )}
                          <div className="slide-box">
                            {devices[i]?.origin_device_ip === '' ? null : (
                              <div style={{ marginBottom: '12px' }}>
                                <span>
                                  {t('原始设备ip:')} {devices[i]?.origin_device_ip}
                                </span>
                              </div>
                            )}
                            {devices[i]?.origin_device_type === '' ? null : (
                              <div style={{ marginBottom: '12px' }}>
                                <span>
                                  {t('原始设备类型:')} {devices[i]?.origin_device_type}
                                </span>
                              </div>
                            )}
                            {devices[i]?.origin_device_brand === '' ? null : (
                              <div style={{ marginBottom: '12px' }}>
                                <span>
                                  {t('设备厂商:')} {devices[i]?.origin_device_brand}
                                </span>
                              </div>
                            )}
                            <div style={{ display: 'flex' }}>
                              <Typography.Paragraph
                                style={{ marginRight: '4px' }}
                                copyable={{
                                  text: item,
                                  icon: [
                                    <IconFont
                                      className="icon"
                                      key={1}
                                      type="icon-fuzhi"
                                      style={{ color: '#999999' }}
                                    />,
                                  ],
                                }}
                              />

                              <div className="log-content">
                                {filtration?.map(values => (
                                  <span
                                    key={values.id}
                                    style={{
                                      marginRight: '6px',
                                      display: 'inline-block',
                                    }}
                                  >
                                    <span className="parseName">{values.name}</span>
                                    <span>：</span>
                                    <span>
                                      {(item &&
                                        typeof item === 'string' &&
                                        JSON.parse(item)?.[values.id]) ||
                                        'null'}
                                    </span>
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>
                        </>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              </div>
            </>
          ) : (
            data?.device_log?.length > 0 && (
              <>
                <div className="line">
                  <div className="title">{t('日志数量：')}</div>
                  <div className="page">
                    <div className={`pag pag${num}`} />
                    <div style={{ display: data?.device_log?.length === 1 ? 'none' : 'block' }}>
                      <div className={`prev less-prev${num}`}>
                        <IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />
                      </div>
                      <div className={`prev next less-next${num}`}>
                        <IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="content1">
                  <Swiper
                    spaceBetween={20}
                    navigation={{
                      prevEl: `.less-prev${num}`,
                      nextEl: `.less-next${num}`,
                      hideOnClick: true,
                    }}
                    pagination={{
                      type: 'fraction',
                      el: `.pag${num}`,
                    }}
                    loop
                  >
                    {content?.map((item, i) => (
                      <SwiperSlide key={i}>
                        {/* {isRaw ? (    */}
                        <div style={{ display: 'flex', background: '#f7f8fa', padding: 10 }}>
                          <Typography.Paragraph
                            style={{ marginRight: '4px' }}
                            copyable={{
                              text: item,
                              icon: [
                                <IconFont
                                  className="icon"
                                  key={1}
                                  type="icon-fuzhi"
                                  style={{ color: '#999999' }}
                                />,
                              ],
                            }}
                          />

                          <div className="log-content">{content?.[i]}</div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </>
            )
          )}
        </LogItem>
      )}
    </>
  )
}

export default DetailLog

const LogItem = styled.div`
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
  .company {
    display: flex;
    align-items: center;
    .text {
      width: calc(100% - 70px);
      color: #666;
    }
  }
  .line {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .title {
      width: 70px;
    }
    .name {
      display: flex;
      justify-content: space-between;
      max-width: 200px;
      color: #86909c;
    }
    .page {
      display: flex;
      width: calc(100% - 80px);
      justify-content: space-between;
      align-items: center;
      .pag {
        max-width: 50px;
        color: #86909c;
      }
    }
  }
  .content1 {
    color: #666666;
    border-radius: 4px;
    width: 100%;

    .slide-box {
      background: #f7f8fa;
      padding: 10px;
    }

    .log-match {
      margin: 10px 0;
    }
  }
  .log-content {
    word-break: break-all;
    line-height: 1.5;

    .light {
      color: #558492;
    }

    .parseName {
      color: #558492;
      margin-left: 4px;
      &:nth-child(1) {
        margin-left: 0;
      }
    }
  }
  .prev {
    display: inline-flex;
    width: 24px;
    height: 24px;
    box-shadow: 0px 2px 4px 0px rgba(95, 103, 129, 0.06);
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    &:hover {
      border: 1px solid #4238c9;
    }
  }
  .next {
    transform: rotateY(180deg);
  }
  .swiper-button-disabled {
    &:hover {
      cursor: no-drop;
      background: #d9d9d9 !important;
    }
  }
  .swiper-pagination-current {
    color: #558492;
  }
`
interface TagProps {
  color: string
}
const TagAlarm = styled.div<TagProps>`
  padding: 3px 4px;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  background: ${props => props.color};
  font-size: 12px;
  flex-shrink: 0;
`

const Tabs = styled.div`
  width: 128px;
  height: 24px;
  font-size: 12px;
  background: #e5e8ed;
  box-shadow: 0px 4px 6px 0px rgba(95, 103, 129, 0.06);
  border-radius: 6px;
  display: flex;
  .tab {
    cursor: pointer;
    width: 64px;
    height: 24px;
    color: #666666;
    background: #e5e8ed;
    border-radius: 6px;
    line-height: 24px;
    text-align: center;
  }
  .active {
    background: #4238c9;
    color: #fff;
  }
`
interface HandleActionProps {
  type: string
}
const HandleAction = styled.span<HandleActionProps>`
  padding: 0 4px;
  color: ${props =>
    props.type === t('放行') ? '#9ed67f' : props.type === t('拦截') ? '#f56969' : ''};
  background: ${props =>
    props.type === t('放行') ? '#e5f1da' : props.type === t('拦截') ? '#fde5e5' : ''};
`
